import React from 'react';

const WhySection = () => {
  return (
    <section id="my-journey" className="py-32 relative" style={{ backgroundColor: '#f8f6f3' }}>
      <div className="container mx-auto px-8">
        <div className="max-w-3xl mx-auto text-center">
          <p 
            className="text-xs tracking-[0.3em] mb-6 font-light"
            style={{ color: '#8b7355' }}
          >
            MY PURPOSE
          </p>
          <h2 
            className="text-2xl md:text-3xl lg:text-4xl font-extralight tracking-[0.1em] leading-relaxed mb-12"
            style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
          >
            Why I Do
            <span className="italic" style={{ color: '#8b7355' }}> What I Do</span>
          </h2>
          
          <div className="space-y-6 text-left md:text-center">
            <p className="text-base font-light leading-relaxed" style={{ color: '#666' }}>
              I've been where you are — overwhelmed, uncertain, wondering if there's more to life than the daily grind.
            </p>
            
            <p className="text-base font-light leading-relaxed" style={{ color: '#666' }}>
              When I discovered digital marketing, everything changed. Not just financially, but in how I saw myself and what was possible.
            </p>
            
            <p className="text-base font-light leading-relaxed" style={{ color: '#666' }}>
              Now, I wake up every day with one mission: to help other women experience that same transformation. To show them that they can build something meaningful, on their own terms, without sacrificing their peace or their purpose.
            </p>
            
            <p className="text-base font-light leading-relaxed" style={{ color: '#1a1a1a' }}>
              <span className="italic" style={{ color: '#8b7355' }}>Because when women have financial freedom, they have choices. And choices change everything.</span>
            </p>
          </div>
          
          <a 
            href="#my-journey"
            className="inline-flex items-center justify-center mt-10 text-xs tracking-[0.2em] px-8 py-4 transition-all duration-300 hover:bg-[#1a1a1a] hover:text-white border"
            style={{ borderColor: '#1a1a1a', color: '#1a1a1a' }}
          >
            MY JOURNEY
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhySection;
